import dataStore from '../store/index.js'
import { storage } from './storage'
import { $request } from './axios/index'
import config from '../config';
import { commonTemplateArr } from '../templates/resumeTemplate.js';
import { Loading } from '../templates/loading.js'
import { getRandomStr } from "./randomStr";

export const getLoginStatusFn = async (callback) => {
  try {
    let userStoreObj = storage.get('login_status') || {};
    // console.log('getLoginStatusFn=>', userStoreObj);
    // userStoreObj = {
    //   username: 'mingle998',
    //   userid: 'cVLW1X1676709440059'
    // }
    // let result: any = await $request.checkLoginStatus({
    //   params: {
    //       uid: userStoreObj.userid || '',
    //       ColaKey: config.globalColaKey || '1234',
    //       sence: 'aiResume'
    //   },
    //   data: {}
    // })
    // if (result.code === 0 && +result.status == 1) { 
    //   callback && callback(true);
    // } else {
    //   callback && callback(false);
    // }

    if (userStoreObj.userid && userStoreObj.username) {
      callback && callback(true);
    } else {
      callback && callback(false);
    }
  } catch (error) {
    callback && callback(false);
    console.log('getLoginStatusFn err catch:', error);
  }
}

export const getUserInfosFn = async (callback) => {
  // const store = useStore()
  let userStoreObj = storage.get('login_status') || {};
  // console.log('getUserInfosFn=>', userStoreObj);
  // userStoreObj = {
  //   username: 'mingle998',
  //   userid: 'cVLW1X1676709440059'
  // }
  // 请求接口获取用户信息
  try {
    let result = await $request.getUserInfos({
      params: {
        username: userStoreObj.username || '',
        userid: userStoreObj.userid || '',
        type: 'init'
      },
      data: {}
    })
    // let result = {
    //   code: 0,
    //   aiResumeDownloadCount: 99,
    //   data: {
    //     userData: {
    //       username: 'mingle998',
    //       userid: 'cVLW1X1676709440059',
    //     }
    //   }
    // };
    // console.log('mock getUserInfosFn=>', result);
    if (+result.code == 0) {
      dataStore.state.userInfos = result.data.userData || {}
      dataStore.state.downloadCount = result.aiResumeDownloadCount || 99;
      // console.log('===>', dataStore.state.userInfos)
      if (dataStore.state.userInfos.username) {
        dataStore.state.isLogin = true
        storage.set('login_status', {
          status: 1,
          userid: dataStore.state.userInfos.userid,
          username: dataStore.state.userInfos.username
        })
        // 更新用户存储的模版
        window.$Bus.emit('emitsetTempDataFn', 1);
      } else {
        dataStore.state.isLogin = false
        storage.set('login_status', {
          status: 0,
          userid: '',
          username: ''
        })
      }
    } else {
    }
    callback && callback();
  } catch (error) {
    console.log('err catch:', error)
    callback && callback();
  }
}

export const updateUserStoreTemplateFn = async (tempStr, store, type = 'update') => { 
  return new Promise(async (resolve, reject) => {
      if (!tempStr) {
          reject({});
      };
      let postData = {
        tempStr: tempStr || store.state.editeResumeObj.htmlStr || '',
        resumeId: store.state.editeResumeObj.resumeId || '',
        title: store.state.editeResumeObj.title || '',
      };
      if (type === 'create') {
        // 如果是创建简历 需要一个新的简历id和标题
        postData.resumeId = `${new Date().getTime()}-` + getRandomStr(12);
        postData.title = '我的简历-' + postData.resumeId;
      } else if (!postData.resumeId) {
        // 如果是更新但是没有简历id 则创建一个新的
        postData.resumeId = `${new Date().getTime()}-` + getRandomStr(12);
      };

      let result = await $request.updateUserStoreTemplate({
        params: {},
        data: {
          tempStr: postData.tempStr,
          type,
          title: postData.title,
          resumeId: postData.resumeId,
          mdStr: store.state.editeResumeObj.mdStr || '',
          uid: store.state.userInfos.userid || '',
          ColaKey: config.globalColaKey || '',
        }
      })
    if (result.code === 0) {
        resolve(result)
    } else {
      reject(result);
    }
  });
}

export const getUserStoreTemplateFn = async (callback, store) => {
  try {
          let result = await $request.getUserStoreTemp({
      params: {},
      data: {
        uid: store.state.userInfos.userid || '',
        ColaKey: config.globalColaKey || '',
      }
    })
    // let result = {
    //   code: 0,
    //   data: {
    //     templateData: localStorage.getItem('userSaveResume')
    //   }
    // }
    if (result.code === 0 && result.data) {
        let templateData = result.data.templateData;
        try {
          let vipData = result.data.userData && result.data.userData.vipData;
          let resumeData = result.data.userData && result.data.userData.resumeData;
          store.state.vipData = vipData || {};
          store.state.resumeData = resumeData || {};
          store.state.editeResumeObj = resumeData.editResumeObj || {};
          store.state.resumeListArr = resumeData.resumeListArr || {};
          console.log('data:', store.state.vipData, store.state.resumeData);
        } catch (error) {
          console.log('set vipData&resumeData err:', error);
        }
        callback && callback(templateData);
      } else {
        callback && callback();
      }
    } catch (error) {
      callback && callback();
      console.log('getUserStoreTemplateFn err catch:', error);
    }
}

// 结合实际数据构造风格模版
export const formatStyleTemplates = (templateData, store) => {
    let allStyleTempArr = [...commonTemplateArr, Loading];
    let curstyleType = '';
    if (templateData.styleType) {
      curstyleType = templateData.styleType;
    }
    console.log('allStyleTempArr:', templateData, allStyleTempArr);
    // 找出用户保存的样式模版
    let useStyleTemp = null;
    let findIndex = allStyleTempArr.findIndex(item => item.styleType == curstyleType);
    if (findIndex > 0 && allStyleTempArr[findIndex]) {
      store.state.curstyleTypeObj = useStyleTemp = allStyleTempArr[findIndex];
    }
    // 组装实际展示的模版
    window.userServerSaveTemplateData = store.state.templateAddCurstyleTypeData = Object.assign({}, templateData, useStyleTemp);
    return {
      allStyleTempArr,
      useStyleTemp,
      templateData,
      templateAddCurstyleTypeData: store.state.templateAddCurstyleTypeData
    };
}

export const getUserStoreTemplateArr = async (store) => { 
  return new Promise((resolve, reject) => {
    getUserStoreTemplateFn((templateData) => {
      if (templateData) {
        if (typeof templateData == 'string') {
          templateData = JSON.parse(templateData || '{}');
          store.state.templateDataObj = templateData;
        }
        let formatStyleTemplatesData = formatStyleTemplates(templateData, store);
        resolve(formatStyleTemplatesData);
      } else {
        reject('获取用户存储的模版失败')
      }
    }, store);
  })
}

// AI生成简历
export const aiCreateResumeFn = async(store, userInfo = '') => {
  return new Promise(async (resolve, reject) => {
      try {
        let result = await $request.aiCreateResume({
          params: {},
          data: {
            uid: store.state.userInfos.userid || '',
            ColaKey: config.globalColaKey || '',
            userInfo,
          }
        })
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('aiCreateAPI err catch:', error);
      }
  })
}

// 创建简历
export const createResumeV2Fn = async (store, resumeData = '') => {
  return new Promise(async (resolve, reject) => {
      try {
        let result = await $request.createResumeV2({
          params: {},
          data: {
            uid: store.state.userInfos.userid || '',
            ColaKey: config.globalColaKey || '',
            resumeData,
          }
        })
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('createResumeV2Fn err catch:', error);
      }
  })
}

// 存储简历PDF
export const saveResumePDF2ServerFn = async (store, payload) => {
  return new Promise(async (resolve, reject) => {
      try {
        // 创建 FormData 对象
        const formData = new FormData();
        formData.append('uid', store.state.userInfos.userid || 'cVLW1X1676709440059');
        formData.append('resume', payload.file);
        formData.append('targetEmail', payload.targetEmail);
        
        // 发送 FormData 格式的请求
        let result = await $request.saveResumePDF2Server({
          params: {},
          data: formData
        }, '', true) // 第三个参数 true 表示使用 FormData 格式
        
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('saveResumePDF2ServerFn err catch:', error);
      }
  })
}

// 查询简历列表
export const getResumeV2ListFn = async (store) => {
  return new Promise(async (resolve, reject) => {
      try {
        let result = await $request.getResumeV2List({
          params: {},
          data: {
            uid: store.state.userInfos.userid || '',
            ColaKey: config.globalColaKey || '',
          }
        })
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('getResumeV2ListFn err catch:', error);
      }
  })
}

// 更新简历
export const updateResumeV2Fn = async (store, updateParams = {
  resumeId: '',
  resumeTitle: '',
  resumeDesc: '',
  resumeData: '',
}) => {
  return new Promise(async (resolve, reject) => {
      try {
        let result = await $request.updateResumeV2({
          params: {},
          data: {
            uid: store.state.userInfos.userid || '',
            ColaKey: config.globalColaKey || '',
            ...updateParams
          }
        })
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('updateResumeV2Fn err catch:', error);
      }
  })
}

// 删除简历
export const deleteResumeV2Fn = async (store, resumeId = '') => {
  return new Promise(async (resolve, reject) => {
      try {
        let result = await $request.deleteResumeV2({
          params: {},
          data: {
            uid: store.state.userInfos.userid || '',
            ColaKey: config.globalColaKey || '',
            resumeId,
          }
        })
        resolve(result);
      } catch (error) {
        reject(error);
        console.log('deleteResumeV2Fn err catch:', error);
      }
  })
}